/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddToFetchDenylistRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {AddToFetchDenylistResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const addToFetchDenylist = (request: AddToFetchDenylistRequest, options?: CashRequestOptions) => post<AddToFetchDenylistRequest, AddToFetchDenylistResponse>("/2.0/cash/add-to-fetch-denylist", request, {...options, rejectOnError: true })